import { CreateFtlShipment } from "~/features/ftl/ftl-shipments/create-ftl-shipment.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const FtlShipmentPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("enableTraxFtlModernized");

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? <CreateFtlShipment /> : <Construction />;
};
